module.exports = __webpack_public_path__ + "static/media/mongo.14eadf8f.jpg";